import Content from '@swarm/ui/presentational/Content'
import Header from '@swarm/ui/swarm/Header'
import { useTheme } from '@swarm/ui/theme/useTheme'
import React from 'react'
import { Box, Flex } from 'rimble-ui'

import Navigation from './Navigation'
import Footer from './Navigation/Footer'

interface LayoutProps {
  children?: React.ReactNode
  subheader?: React.ReactNode
  CustomNavigation?: React.ReactNode
  header?: React.ReactNode
  scrollable?: boolean
  headerActions?: React.ReactNode
}

const Layout = ({
  children,
  CustomNavigation,
  header,
  subheader,
  scrollable = false,
  headerActions,
}: LayoutProps) => {
  const theme = useTheme()

  const mobileTopFixedHeight = theme.layout.navigationBar.heightPixels

  return (
    <Flex
      width="100%"
      height="100vh"
      flexDirection={['column', 'row']}
      justifyContent="flex-start"
      transform="translateZ(0)"
    >
      {CustomNavigation === undefined ? <Navigation /> : CustomNavigation}

      <Content
        noPadding
        fullScreen={!scrollable}
        width={['100%', 'calc(100% - 304px)']}
        minHeight="100vh"
        marginTop={[mobileTopFixedHeight, 0]}
        marginLeft={[0, theme.layout.navigationBar.desktopWidthPixels]}
      >
        {header !== undefined ? (
          <Header
            title={header}
            subheader={subheader}
            position={scrollable ? 'sticky' : 'relative'}
            top={scrollable ? [mobileTopFixedHeight, 0] : 0}
            zIndex={theme.zIndices.layerOne}
            shadowOnScroll={scrollable}
          >
            {headerActions}
          </Header>
        ) : null}

        {children}

        <Box
          display={['block', 'none']}
          flexShrink={0}
          width="100%"
          height={theme.layout.footer.heightPixels}
        />
      </Content>

      <Footer isMobile />
    </Flex>
  )
}

export default Layout
